const getSelectionId = (selectionData) => selectionData.get('id');
const getSelectionText = (selectionData) => selectionData.get('text');

export {getSelectionText, getSelectionId}